import React from 'react'
import {Carousel} from "react-responsive-carousel"
import img1 from "../assets/3.jpg"
import img2 from "../assets/4.jpg"
import img3 from "../assets/5.jpg"
import img4 from "../assets/6.jpg"
import "react-responsive-carousel/lib/styles/carousel.min.css"

const Services = () => {
  return (
    <div className="services">
    <Carousel
    infiniteLoop
    autoPlay
    showArrows={false}
    showIndicators={false}
    showThumbs={false}
    interval={1000}
    showStatus={false}
    >
    <div>
        <img src={img1} alt="Item1" />
        <p className="legend">Full Stack</p>
    </div>
    <div>
        <img src={img2} alt="Item2" />
        <p className="legend">Hypercare</p>
    </div>
    <div>
        <img src={img3} alt="Item3" />
        <p className="legend">M&O</p>
    </div>
    <div>
        <img src={img4} alt="Item4" />
        <p className="legend">Security</p>
    </div>
    </Carousel>
    </div>
  )
}

export default Services